export const config = {
  API_BASE_URL: process.env.VUE_APP_IOFFICE_API,
  ssoConfig: {
    authUrl: process.env.VUE_APP_SSO_AUTH_URL,
    clientId: process.env.VUE_APP_SSO_CLIENT_ID,
    redirectUri: process.env.VUE_APP_SSO_REDIRECT_URI,
    scope: process.env.VUE_APP_SSO_SCOPE,
    responseType: process.env.VUE_APP_SSO_RESPONSE_TYPE,
    allowedSSO: process.env.VUE_APP_SSO_ALLOWED,
    ssoLogoutUri: process.env.VUE_APP_SSO_LOGOUT_URI,
    loginUri: process.env.VUE_APP_LOGOUT_URI,
    ssoHealth: process.env.VUE_APP_SSO_HEALTH,
  },
};
